import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function ArheoIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="ArheoIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <circle fill="#FFFFFF" cx="32.3" cy="63.2" r="15.6"/>
      <circle fill="#FFFFFF" cx="67.7" cy="63.2" r="15.6"/>
      <circle fill="#FFFFFF" cx="50" cy="31.5" r="15.6"/>
      <path fill="#3CAA78" d="M61.8,31.5c0-6.5-5.3-11.8-11.8-11.8S38.2,25,38.2,31.5S43.5,43.3,50,43.3C56.5,43.2,61.8,38,61.8,31.5z"/>
      <path fill="#3CAA78" d="M79.5,63.2c0-6.5-5.3-11.8-11.8-11.8s-11.8,5.3-11.8,11.8C56,69.7,61.2,75,67.7,75S79.5,69.7,79.5,63.2z"/>
      <path fill="#3CAA78" d="M44,63.2c0-6.5-5.3-11.8-11.8-11.8s-11.8,5.3-11.8,11.8S25.7,75,32.2,75C38.8,75,44,69.7,44,63.2z"/>
    </svg>
  </SvgIcon>
}

export default ArheoIcon;
